<template>
  <main class="app-content" :short="true">
    <div class="m-5 pt-5">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <audience-list
              :data="audienceListData"
              @on-edit-clicked="handleEditClicked"
              @on-delete-clicked="handleDeleteClicked"
            >
              <template v-slot:header>
                <div
                  class="d-flex align-items-center justify-content-between mb-4"
                >
                  <h2>Audiences</h2>
                  <app-primary-button
                    label="Create Audience"
                    v-on:click.native="goToAudienceForm()"
                  ></app-primary-button>
                </div>
              </template>
            </audience-list>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import AudienceList from '../../components/Audience/AudienceList';
import ApiCallMixin from '../../mixins/ApiCallMixin';
import AudienceServiceV2 from '../../services/V2/AudienceServiceV2';
import {AudienceListData} from '../../components/Audience/AudienceList/AudienceListData';
import AppPrimaryButton from '../../components/AppComponents/Forms/AppPrimaryButton.vue';

export default {
  mixins: [ApiCallMixin],
  components: {
    AudienceList,
    AppPrimaryButton,
  },
  data() {
    return {};
  },
  computed: {
    audienceListData() {
      const data = new AudienceListData();

      if (
        this.api['AUDIENCE-LIST'] &&
        this.api['AUDIENCE-LIST'].response &&
        this.api['AUDIENCE-LIST'].response.data &&
        this.api['AUDIENCE-LIST'].response.data.data
      ) {
        const audiences = this.api['AUDIENCE-LIST'].response.data.data;

        if (Array.isArray(audiences)) {
          audiences.forEach((audience) => {
            data.addRow(
              audience.id,
              audience.name,
              audience.scope,
              audience.scopeDisplay,
              audience.assignments,
              audience.createdBy,
              audience.createdAt,
              audience.updatedAt,
            );
          });
        }
      }

      return data;
    },
  },
  methods: {
    handleEditClicked(row) {
      this.goToAudienceForm(row.id);
    },
    handleDeleteClicked(row) {
      this.$swal({
        type: 'warning',
        title: 'Delete audience?',
        text: `Are you sure you want to delete ${row.name}?`,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value === true) {
          await this.request(
            'DELETE-AUDIENCE',
            AudienceServiceV2.deleteAudience,
            row.id
          );
          this.request('AUDIENCE-LIST', AudienceServiceV2.getAudiences);
        }
      });
    },
    handleEditCancelClicked() {
      this.mode = 'create';
    },
    goToAudienceForm(audienceId) {
      this.$router.push({name: 'AudienceFormPage', query: {audienceId}});
    },
  },
  mounted() {
    this.registerApis(['AUDIENCE-LIST']);
    this.registerApis(['DELETE-AUDIENCE']);
    this.request('AUDIENCE-LIST', AudienceServiceV2.getAudiences);
  },
};
</script>
